<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">IVA Compras</h1>
          <p class="view-header__subtitle">Resumen del IVA crédito fiscal por alícuota.</p>
        </div>
      </div>
    </div>

    <!-- STATS PRINCIPALES -->
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(subtotal) }}</div>
          <div class="stats-card__label">Total neto gravado</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(tax) }}</div>
          <div class="stats-card__label">Total IVA</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(total) }}</div>
          <div class="stats-card__label">Total compras</div>
        </div>
      </div>
    </div>

    <!-- DESGLOSE POR ALÍCUOTA -->
    <div class="form-card">
      <div class="form-card__header">
        <h6 class="form-card__title">
          <i class="bi bi-percent"></i>
          Desglose por alícuota
        </h6>
      </div>
      <div class="form-card__body">
        <div class="iva-grid">
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax25) }}</div>
            <div class="iva-tile__label">IVA 2,5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax50) }}</div>
            <div class="iva-tile__label">IVA 5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax105) }}</div>
            <div class="iva-tile__label">IVA 10,5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax210) }}</div>
            <div class="iva-tile__label">IVA 21%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax270) }}</div>
            <div class="iva-tile__label">IVA 27%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(ewivaamount) }}</div>
            <div class="iva-tile__label">Retención IVA</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(ewamount) }}</div>
            <div class="iva-tile__label">Retención ganancias</div>
          </div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model="invoiceType" :options="invoiceTypeOptions" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="branchoffice_id" :options="branchofficeOptions" placeholder="Todas las sucursales" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange
              :opendir="'left'"
              :initial-start="startDate"
              :initial-end="endDate"
              @datepicked="dateCreated"
            />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import Daterange from "../global/Daterange-component.vue";
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import formatDateMixin from "../../mixins/formatDateMixin";
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    VdtnetTable,
    Daterange,
    QSelect,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      loading: false,
      invoiceType: "",
      startDate: null,
      endDate: null,
      branchoffice_id: null,
      subtotal: null,
      ewamount: null,
      ewivaamount: null,
      tax25: null,
      tax50: null,
      tax105: null,
      tax210: null,
      tax270: null,
      tax: null,
      total: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/ivapurchases",
          type: "GET",
          data: (d) => {
            d.invoiceType = this.invoiceType;
            d.daterange = this.daterange;
            d.branchoffice_id = this.branchoffice_id;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 50,
        searching: true,
        searchDelay: 400,
        destroy: true,
        order: [[0, 'desc']],
        ordering: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        dateHour: { label: "Fecha" },
        receipt: { label: "Comprobante" },
        provider_name: {
          label: "Proveedor",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || ''}</span>` : data,
        },
        provider_cuit: { label: "CUIT" },
        'taxes.2.5': { label: "2,5%", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.5': { label: "5%", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.10.5': { label: "10,5%", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.21': { label: "21%", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.27': { label: "27%", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.internalTax': { label: "Imp. internos", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.perceptionTax': { label: "Perc. IVA", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.lofty': { label: "Exento", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.otherTax': { label: "Otros imp.", align: "right", render: this.formatoDinamicoMoneda },
        'taxes.iibb': { label: "Perc. IIBB", align: "right", render: this.formatoDinamicoMoneda },
        subtotal: { label: "Subtotal", align: "right", render: this.formatoDinamicoMoneda },
        total: { label: "Total", align: "right", render: this.formatoDinamicoMoneda },
      },
    };
  },
  computed: {
    ...mapState('branchoffices', ['branchoffices']),
    invoiceTypeOptions() {
      return [
        { value: '', label: 'Todos los tipos' },
        { value: 'FC', label: 'FC' },
        { value: 'NC', label: 'NC' },
        { value: 'ND', label: 'ND' },
      ];
    },
    branchofficeOptions() {
      return this.branchoffices.map(b => ({ value: b.id, label: b.name }));
    },
    daterange() {
      if (this.startDate === null || this.endDate === null) return null;
      const startDate = this.formatoFecha2Daterange(this.startDate);
      const endDate = this.formatoFecha2Daterange(this.endDate);
      return `${startDate} - ${endDate}`;
    },
    filters() {
      return {
        invoiceType: this.invoiceType,
        daterange: this.daterange,
        branchoffice_id: this.branchoffice_id,
      };
    },
  },
  watch: {
    filters() {
      this.refreshTable();
      this.getTotals();
    },
  },
  mounted() {
    this.setDefaultDateRange();
    this.$store.dispatch('branchoffices/getAllBranchoffices');
    this.getTotals();
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    dateCreated(date) {
      this.startDate = date.startDate;
      this.endDate = date.endDate;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
    setDefaultDateRange() {
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.startDate = this.formatDate(startOfMonth);
      this.endDate = this.formatDate(today);
    },
    getTotals() {
      this.loading = true;
      this.$http.get("/api/reports/statsivapurchases", { params: this.filters })
        .then((response) => {
          const d = response.data.data;
          this.subtotal = d.subtotal;
          this.ewamount = d.ewamount;
          this.ewivaamount = d.ewivaamount;
          this.tax25 = d.tax25;
          this.tax50 = d.tax50;
          this.tax105 = d.tax105;
          this.tax210 = d.tax210;
          this.tax270 = d.tax270;
          this.tax = d.tax;
          this.total = d.total;
        })
        .catch((error) => {
          console.error('getTotals:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportCSV() {
      this.$http.post("/api/reports/CSVpurchaseIVA", this.filters);
    },
    exportPDF() {
      this.$http.post("/api/reports/PDFpurchaseIVA", this.filters);
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}

.iva-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
}

.iva-grid > .iva-tile {
  flex: 1 1 0;
  min-width: 0;
}

@media (max-width: 767px) {
  .iva-grid {
    flex-wrap: wrap;
  }

  .iva-grid > .iva-tile {
    flex: 1 1 calc(50% - 4px);
  }
}

.iva-tile {
  text-align: center;
  padding: 12px 8px;
  border-radius: 8px;
  background: var(--surface-subtle);
  border: 1px solid var(--border-soft);
}

.iva-tile__value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.iva-tile__label {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 4px;
  font-weight: 500;
}
</style>
